
<div class="scroll-container">
  <div class="column-selection h-100">
    <div v-for="(group, index) in filteredReportColumns" :key="group.key" class="column-group mb-4">
      <template v-if="group.source && (index === 0 || filteredReportColumns[index - 1].source !== group.source)">
        <div class="py-3 px-4 font-weight-bold" style="font-size: 16px; color: #3F3F3F;">
          {{ group.source === 'case' ? 'Case Columns' : 'Client Columns' }}
        </div>
      </template>
      <div class="column-header py-3 px-4">
        <div class="d-flex justify-content-between">
          <div class="custom-control custom-checkbox">
            <input type="checkbox" :id="'checkGroup_' + group.key" :checked="isGroupSelected(group)"
              class="custom-control-input" @change="toggleGroupSelection(group)"
              :disabled="!group.data || group.data.length === 0 || group.key === 'Questionnaire::Template'" />
            <label class="custom-control-label font-weight-bold" :for="'checkGroup_' + group.key"
              style="font-size: 16px;">
              {{ getGroupLabel(group) }}
            </label>
          </div>
          <v-menu v-if="group.key === 'Task::Dictionary'" min-width="300px" bottom :close-on-content-click="false"
            nudge-bottom="24px">
            <template v-slot:activator="{ on, attrs }">
              <div role="button" v-bind="attrs" v-on="on" class="d-flex align-items-center">
                <span class="ma-0 mr-1" style="color: #3F3F3F; font-size: 12px;">Sort & Filter</span>
                <v-icon small dense color="#3F3F3F">mdi-filter</v-icon>
              </div>
            </template>
            <div class="bg-white p-3">
              <div class="status">
                <span class="mb-2 font-weight-bold d-block">Sort</span>
                <c-select-new class="notranslate" placeholder="Latest" v-model="tempFilter.sort"
                  :options="sortOptions" item-text="text" item-value="value" />
              </div>
              <div class="status mt-4">
                <span class="mb-2 font-weight-bold d-block">Filter - Used on procedure</span>
                <div v-for="option in modifiedProcedureListFilter" :key="option.id" class="checkbox-status">
                  <input class="mr-2" @change="checkAll(option.id)" type="checkbox" :id="option.id" :value="option.id"
                    v-model="tempFilter.procedure_ids" />
                  <label :for="option.id" class="ma-0">{{ option.name }}</label>
                </div>
              </div>
              <v-divider color="#D7D7D7" class="my-3"></v-divider>
              <div class="d-flex action justify-content-between mt-2">
                <CButton @click.native="clearAdditionalFilter" :outline="true" :color="'#007BFF'" label="Clear">
                </CButton>
                <CButton @click.native="applyFilter" :color="'#007BFF'" label="Apply">
                </CButton>
              </div>
            </div>
          </v-menu>
        </div>
      </div>

      <!-- Only render column-child if group.data exists and is an array or object -->
      <div class="column-child py-2 px-4" v-if="group.data && (isKeyValue(group.data) || Array.isArray(group.data))">
        <p v-if="reportTemplate.type === 'Report::Client' && group.key === 'case_detail'" class="ma-0 mb-2"
          style="font-size: 14px;">FastVisa retrieves the <b>latest priority date</b> associated with the specific
          client.</p>
        <p v-if="reportTemplate.type === 'Report::Case' && group.key === 'client_detail'" class="ma-0 mb-2"
          style="font-size: 14px;">FastVisa retrieves the <b>latest priority date</b> from the <b>Priority Date
            module</b>
          within the case.</p>
        <p v-if="reportTemplate.type === 'Report::Join' && group.key === 'client_detail'" class="ma-0 mb-2"
          style="font-size: 14px;">FastVisa retrieves the <b>latest priority date</b> associated with the specific
          client.</p>
        <template v-if="group.key === 'Questionnaire::Template'">
          <v-select dense placeholder="Select Questionnaire" hide-details solo flat clearable
            class="input-border ml-6" :items="group.data" @change="onQuestionnaireChange"
            v-model="selectedQuestionnaire" item-value="id" return-object>
            <template v-slot:selection="{ item }">
              <span style="color: #3F3F3F !important;">#{{ item.id }} {{ item.name }}</span>
            </template>
            <template v-slot:item="{ item }">
              <span>#{{ item.id }} {{ item.name }}</span>
            </template>
          </v-select>
          <p class="ma-0 mt-2 ml-6" style="font-size: 14px;">The data displayed for the preview of this survey
            questionnaire is
            sample data. It will not be exported.</p>
        </template>

        <template v-else-if="isKeyValue(group.data)">
          <div v-for="(header_name, columnName) in group.data" :key="group.key + '_' + columnName"
            class="column-item d-flex align-items-center mb-2">
            <div class="custom-control custom-checkbox">
              <input type="checkbox" :id="'checkColumn_' + group.key + '_' + columnName"
                :checked="selectedColumns.some(col => col.group === group.key && col.columnName === columnName)"
                class="custom-control-input" @change="toggleColumnSelection(columnName, group.key, header_name)" />
              <label class="custom-control-label" :for="'checkColumn_' + group.key + '_' + columnName">
                {{ header_name }}
              </label>
            </div>
          </div>
        </template>

        <template v-else>
          <div v-for="item in group.data" :key="group.key + '_' + item.id"
            class="column-item d-flex align-items-center mb-2">
            <div class="custom-control custom-checkbox">
              <input type="checkbox" :id="'checkColumn_' + group.key + '_' + item.id"
                :checked="selectedColumns.some(col => col.group === group.key && col.columnName === item.id)"
                class="custom-control-input"
                @change="toggleColumnSelection(item.id, group.key, item.name || item.header_name || item.title || item.label)" />

              <label v-if="['Label::Case', 'Label::Ticket', 'Label::User'].some(label => group.key.includes(label))"
                class="custom-control-label sticker" :for="'checkColumn_' + group.key + '_' + item.id"
                :style="{ backgroundColor: item.color }">
                {{ item.name }}
              </label>

              <label v-else class="custom-control-label" :for="'checkColumn_' + group.key + '_' + item.id">
                {{ item.name || item.header_name || item.title || item.label }}
                <v-tooltip v-if="group.key === 'Task::Dictionary' && item.procedure_count > 0" bottom
                  content-class="tooltip">
                  <template v-slot:activator="{ on, attrs }">
                    <span v-bind="attrs" v-on="{ ...on, mouseover: () => fetchProcedures(item) }" class="font-italic"
                      style="color: #007BFF; font-size: 12px;">Used in {{
                        item.procedure_count }} procedure(s)</span>
                  </template>
                  <span style="background-color: white;">
                    <b class="ma-0">Procedure(s)</b>
                    <ul class="mt-2 ma-0">
                      <li v-if="item.isFetchingProcedure" class="ma-0">Loading...</li>
                      <template v-else-if="Array.isArray(item.procedures) && item.procedures.length > 0">
                        <li class="ma-0" v-for="proc in item.procedures" :key="proc.id">
                          {{ proc.name }}
                        </li>
                      </template>
                      <li v-else class="ma-0">No procedures found</li>
                    </ul>
                  </span>
                </v-tooltip>
                <span v-else-if="group.key === 'Task::Dictionary' && item.procedure_count > 0" class="font-italic"
                  style="color: #007BFF; font-size: 12px;">Used
                  in {{
                    item.procedure_count }}
                  procedure(s)</span>
                <i v-else-if="group.key === 'Task::Dictionary'" style="color: #6c757d; font-size: 12px;">
                  Not yet used in Procedure.
                </i>
              </label>
            </div>
          </div>
        </template>
      </div>
      <p v-if="group && group.data && group.data.length === 0"
        class="d-flex justify-content-center align-items-center h-100">
        No Columns Available</p>
    </div>
    <p v-if="reportColumns.length === 0" class="d-flex justify-content-center align-items-center h-100">No Columns
      Available
    </p>
  </div>
</div>
